import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { startLogin } from 'helpers/credentials';
import OverlayBackButton from 'components/bolt/overlayBackButton/overlayBackButton';
import Store from 'store/store';
import s from 'components/bolt/login/login.sss';


export default class Login extends Component {
	constructor(props) {
		super(props);
	}

	onBackClick() {
		Store.emit('SHOW_LOGIN_SCREEN', { show: false });
		Store.emit('RESET_DESIRED_SCREEN');
	}

	onLogin() {
		startLogin();
	}

	onStartHereClick() {
		Store.emit('TRACK_GET_PRIME');
	}

	render(props) {
		const { showtimesStore, appData, client } = props;
		const show = showtimesStore?.showLoginScreen;
		const hasPrimeBlock = showtimesStore?.showPrimeBlock;
		const imageRoot = appData?.urls?.roots?.image || '';
		const copy = appData?.copy?.baseCopy || {};

		return (
			<div class={joinClasses(s.container, show && s.show)}>
				<OverlayBackButton
					ariaLabel="back"
					onClick={this.onBackClick}
					client={client}
				/>
				<div class={s.content}>
					<img class={s.logo} src={`${imageRoot}/prime_premiere.png`} alt="logo" />
					<p class={s.text}>{copy.$BANNER_TEXT}</p>
					<p class={s.date}>{copy.$EVENT_DATE}</p>
					{hasPrimeBlock && <p class={s.primeBlock}>{copy.$PRIME_BLOCK}</p>}
					<button class={s.btn} onClick={this.onLogin}>
						<img class={s.loginWithAmazon} src={`${imageRoot}/btnLWA_amazon_orange_312x64.png`} alt="Login with Amazon" />
					</button>
					<p class={s.newCustomer}>
						<span>{copy.$NEW_CUSTOMER}</span>
						<a class={s.startHere} href="https://www.amazon.com/prime?reftag_=std_PVPPremiereSGW" target="_blank" onClick={this.onStartHereClick}>{copy.$START_HERE}</a>
					</p>
				</div>
			</div>
		);
	}
}
